<template>
<div class="chapter">
<div class="inner_page">
<div class="calibre3" id="calibre_pb_0"></div>
<div class="calibre4">
<div class="p_norm-center__and__page_break"><span><img alt="" class="calibre5" src="OPS/image0.jpg"/></span></div>
</div>
<div class="calibre4">
<div class="p_norm-center"><span><img alt="" class="calibre5" src="OPS/image1.jpg"/></span></div>
</div>
<div class="calibre4">
<div class="p_norm-center"><span><img alt="" class="calibre5" src="OPS/image2.jpg"/></span></div>
</div>
<div class="calibre4">
<div class="p_norm-center"><span><img alt="" class="calibre5" src="OPS/image3.jpg"/></span></div>
</div>
<div class="calibre4">
<div class="p_norm-center__and__page_break"><span><img alt="" class="calibre5" src="OPS/image4.jpg"/></span></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0003.vue?b619b1c4